import {
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  SvgIcon,
  Box,
  Tooltip,
  styled,
  TooltipProps,
  tooltipClasses,
} from '@mui/material';
import {AppliedTileProps, RECRUITER_ACTION_TEXT} from '../types';
import {Avatar} from '@jobseeker/lotus/components';
import {
  fetchJobDetails,
  fetchJobInsights,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobdetail';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';
import {Image} from '@jobseeker/lotus/components/Image';
import {useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {handleTracking, openUrl, TrackEventUBA} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {useEffect, useRef, useState} from 'react';
import {userService} from '@jobseeker/common-core/services';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import ScheduledInterview from './ScheduledInterview';
import LockedStatus from './LockedStatus';
import {useIsCustomWidth, useInView} from '@jobseeker/lotus/hooks';
import {JobdetailQr} from '@jobseeker/lotus/assets/images';
import {borderRadius} from '@mui/system';
import {Comment, LineChart, UserDP} from '@jobseeker/lotus/assets/icons';

const TooltipHirist = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  ul: {
    margin: 0,
    padding: '14px 15px',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#1c2d41',
    color: '#fff',
    fontSize: 16,
    // border: '1px solid #dadde9',
  },
  '.MuiTooltip-arrow:before': {
    backgroundColor: '#1c2d41',
  },
}));
const AppliedTileV2 = ({
  id,
  applicantId,
  applicationId,
  applicationDate,
  recruiterDetail,
  recruiterAction,
  jobDetail,
  followUp,
  views,
  app_count,
  unpublishInfo,
  confidential,
  app_status,
  recruiterActions,
  inviteStatus,
  lastActive,
  isPro,
  hasfollowup,
  interviewDate,
  interviewTime,
  slotId,
  calId,
  remSlots,

  setshowProMembershipPrompt,
  setShowFollowUpProMembershipPrompt,
  setInsightsbox,
  setShowStatusProMembershipPrompt,
}: AppliedTileProps) => {
  const membershipStatus = isPro ? 'Pro' : 'No Membership';
  const trackClick = (section: string) => {
    TrackEventUBA('appliedJobsPageClick', 'click', {
      ref: (router.query?.ref as string) || '',
      pageName: 'Applied Jobs Page',
      jobID: jobDetail.id,
      section,
      membershipStatus,
      sessionUsername: sessionStorage.getItem('userId') || '',
    });
  };
  lastActive = lastActive || {
    lastActiveDate: new Date().toISOString(),
  };
  const loc = jobDetail.location.map(obj => {
    return obj.name;
  });

  const router = useRouter();
  const [followedUp, setFollowedUp] = useState(followUp.status);
  const isMedium = useIsCustomWidth(1024);
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  // useValidateAuth(dispatch);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const textRef = useRef<HTMLAnchorElement>(null);
  function removeHtmlAndAppendRef(url: string) {
    // Remove ".html" at the end if present
    const cleanedUrl = url.endsWith('.html') ? url.slice(0, -5) : url;

    // Check if the URL already contains a query string
    if (cleanedUrl.includes('?')) {
      return `${cleanedUrl}&ref=apj`;
    }

    // If no query string is present, append `?ref=akf`
    return `${cleanedUrl}?ref=apj`;
  }

  const jobUrl = removeHtmlAndAppendRef(jobDetail.jobUrl);
  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;

      // Calculate if the content overflows beyond two lines
      const hasOverflow = element.scrollHeight > element.clientHeight;
      setIsTooltipVisible(hasOverflow);
    }
  }, [jobDetail.title]);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const selectedText = window.getSelection()?.toString();
    if (selectedText) return;
    trackClick('Job');
    openUrl(jobUrl, '_blank', 'noopener,noreferrer');
  };
  const jd: JB = useSelector((state: any) => state.jobDetail);

  useEffect(() => {
    if (jd && jd.id === jobDetail.id) {
      console.log('jobDetails', jd);
      setInsightsbox(true);
    }
  }, [jd, jobDetail.id]);

  const {ref: recruiterActionRef, isInView: recruiterActionInView} = useInView({triggerOnce: true});
  useEffect(() => {
    if (recruiterActionInView && app_status !== 0) {
      TrackEventUBA('recruiterActionView', 'view', {
        ref: (router.query?.ref as string) || '',
        pageName: 'Applied Jobs',
        jobID: jobDetail.id,
        membershipStatus,
        recruiterAction: RECRUITER_ACTION_TEXT[app_status] || '',
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
    }
  }, [recruiterActionInView]);

  const openInsightsDialog = async () => {
    trackClick('Insights');
    if (!isPro) {
      setshowProMembershipPrompt(true);
    } else {
      try {
        await dispatch(fetchJobDetails({jobId: String(jobDetail.id)}));
        await dispatch(
          fetchJobInsights({
            userId: String(applicantId),
            jobId: String(jobDetail.id),
          })
        );

        handleTracking('prostatusview', {
          event_category: 'insightpopup',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: router.pathname,
          Type: 'view',
          CompanyId: recruiterDetail.organisationId,
        });
      } catch (error) {
        console.error('Error fetching job insights:', error);
      }
    }
  };

  const handleJobFollowup = () => {
    trackClick('Follow Up');
    if (!isPro) {
      setShowFollowUpProMembershipPrompt(true);
    } else {
      handleTracking('ClickFollowUp', {
        event_category: 'Job',
        Origin: router.pathname,
        Source: 'JobDescription',
        CategoryId: jobDetail.categoryId,
        JobId: jobDetail.id,
        RecruiterId: recruiterDetail?.recruiterId,
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });

      (async () => {
        try {
          const followUp = await jobDetailService.doFollowUp({
            jobId: jobDetail.id,
          });
          if (typeof followUp === 'boolean') {
            // await userService.updateFollowUp();
            setFollowedUp(followUp);
          }
        } catch (error: unknown) {
          console.log('🚀 ~ file: index.tsx:298 ~ error:', error);
        }
      })();
    }
  };

  const initiateChat = () => {
    if (!(window as any).chatObject) return;

    (window as any).chatObject.initiateChat({
      type: 'j', // r- recruiter, j- jobseeker
      userId: applicantId,
      recipientId: recruiterDetail.recruiterId,
      tokenName: `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_CK1`,
    });
    console.log(applicantId, recruiterDetail.recruiterId);
  };
  const formatPostedTime = (createdTime: string | number): string => {
    const jobTime = new Date(createdTime);
    const formattedDate = `${jobTime.getDate()}-${
      jobTime.getMonth() + 1
    }-${jobTime.getFullYear()}`;
    return `Posted on: ${formattedDate}`;
  };
  return (
    <Card
      data-testid="applied-desktop-card"
      sx={{
        margin: 0,
        boxShadow: '0 4px 14px 0 rgba(0,0,0,.03)',
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 2,
        marginTop: 1,
        borderRadius: 2,
        border: 'solid 1px',
        borderColor: '#f2f5fa',
      }}
    >
      {/* First Content Section */}
      <CardContent
        data-testid="applied-desktop-header"
        sx={{
          padding: '11px 14px 10px 19px',
          marginTop: 0,
          paddingTop: '3px',
          marginLeft: 0,
          paddingLeft: 0,
          marginRight: 0,
          paddingRight: 0,
          borderBottom: 'solid 1px',
          borderColor: '#f2f5fa',
        }}
      >
        <Grid
          container
          direction="row"
          spacing={0}
          paddingLeft={0}
          marginLeft={0}
          paddingRight={0}
          marginRight={0}
        >
          {/* Date */}
          <Grid item paddingLeft={0} marginTop={1.5} xxs={4.7}>
            <Box display={'flex'}>
              <Image
                data-testid="applied-desktop-job-icon"
                src={UserDP}
                alt="dp"
                width={15}
                height={15}
                style={{marginTop: '4px', marginLeft: '24px'}}
              />
              <Typography
                data-testid="applied-desktop-job-title"
                variant="body2"
                color="textPrimary"
                sx={{
                  marginLeft: 1,
                  cursor: 'pointer',
                  paddingLeft: 0,
                  paddingTop: 0,
                  fontSize: 16,
                  fontweight: 400,
                  fontStyle: 'normal',
                  '&:hover': {
                    textDecoration: 'underline', // Add underline on hover
                  },
                }}
                onClick={handleClick}
              >
                {' '}
                {`${jobDetail.title.replace(/\(.*?\)/g, '').trim()}`}
                {/* Match size and color */}
              </Typography>
            </Box>
          </Grid>

          {/* Title and Subtext */}
          <Grid item marginLeft={0} marginTop={1.5} xxs={1.21}>
            <Typography
              data-testid="applied-desktop-application-date"
              variant="body2"
              sx={{
                cursor: 'default',
                textDecoration: 'none',
                paddingTop: 0,
                paddingBottom: 0,
                marginBottom: 0,
                maxHeight: 40,
                textAlign: 'center',
                color: '#000',
                opacity: 0.8,
                fontSize: 16,
                fontweight: 400,
                fontStyle: 'normal',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none',
                },
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',

                whiteSpace: 'normal',
              }}
            >
              {new Date(applicationDate)
                .toLocaleDateString('en-GB')
                .split('/')
                .join('-')}
            </Typography>
          </Grid>

          {/* Views */}
          <Grid item marginTop={1.5} xxs={1.21}>
            <Typography
              data-testid="applied-desktop-views"
              variant="body2"
              sx={{
                cursor: 'default',
                marginTop: 0,
                opacity: 0.8,

                paddingTop: 0,
                fontSize: 16,
                textAlign: 'center',
                fontweight: 400,
                fontStyle: 'normal',
              }}
            >
              {views?.toString()}
            </Typography>
          </Grid>

          {/* Applications */}
          <Grid item marginLeft={0} marginTop={1.5} xxs={1.21}>
            <Typography
              data-testid="applied-desktop-applications"
              variant="body2"
              sx={{
                cursor: 'default',
                marginTop: 0,
                paddingTop: 0,
                textAlign: 'center',
                opacity: 0.8,

                fontSize: 16,
                fontweight: 400,
                fontStyle: 'normal',
              }}
            >
              {app_count?.toString()}
            </Typography>
          </Grid>

          {/* Actions */}
          <Grid item marginLeft={0} marginTop={1.5} xxs={1.21}>
            <Typography
              data-testid="applied-desktop-actions"
              variant="body2"
              sx={{
                cursor: 'default',
                textAlign: 'center',
                opacity: 0.8,

                marginTop: 0,
                paddingTop: 0,
                fontSize: 16,
                fontweight: 400,
                fontStyle: 'normal',
              }}
            >
              {recruiterActions?.toString()}
            </Typography>
          </Grid>

          {/* Status */}
          <Grid item ref={recruiterActionRef} marginLeft={0} marginTop={1.5} xxs={1.21}>
            {isPro ||
            !isPro ||
            RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT' ? (
              <Typography
                data-testid="applied-desktop-status"
                variant="body2"
                sx={{
                  cursor: 'default',
                  marginTop: 0,
                  paddingTop: 0,
                  fontSize: 16,
                  textAlign: 'center',
                  opacity: 0.8,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#000',
                }}
              >
                {RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT'
                  ? 'Applied/Sent'
                  : RECRUITER_ACTION_TEXT[app_status].charAt(0).toUpperCase() +
                    RECRUITER_ACTION_TEXT[app_status].slice(1).toLowerCase()}
              </Typography>
            ) : (
              <LockedStatus
                setShowStatusProMembershipPrompt={
                  setShowStatusProMembershipPrompt
                }
              />
            )}
          </Grid>

          {/* Follow Up Button */}
          <Grid
            item
            marginTop={0.5}
            marginLeft={0}
            sx={{display: 'flex', justifyContent: 'center'}}
            xxs={1.21}
          >
            {app_status == 1 && !confidential ? (
              <>
                <div style={{flexGrow: 1}} />
                <Box display={'flex'}>
                  <Image
                    src={Comment}
                    alt="lc"
                    width={15}
                    height={15}
                    style={{
                      marginRight: '4px',
                      marginTop: '24px',
                      marginLeft: '-60px',
                    }}
                  ></Image>{' '}
                  <Typography
                    onClick={initiateChat}
                    component="span"
                    sx={{
                      cursor: 'pointer',
                      fontSize: 13,
                      fontWeight: 400,
                      letterSpacing: '0.48px',
                      color: '#e9630c',
                      verticalAlign: 'super',
                      marginBottom: 0,
                      mt: 3,
                    }}
                  >
                    Chat with Recruiter
                  </Typography>
                </Box>
              </>
            ) : isPro && !hasfollowup && app_status <= 0 ? (
              <TooltipHirist
                arrow
                title="Oops!! You don't have any more follow ups left."
                disableInteractive
              >
                <span>
                  <Button
                    data-testid="applied-desktop-followup-btn"
                    disabled={
                      followedUp ||
                      (isPro && !hasfollowup) ||
                      (app_status > 0 && isPro == true)
                    }
                    onClick={handleJobFollowup}
                    variant="outlined"
                    color="primary"
                    sx={{
                      borderRadius: '4px',
                      width: followedUp ? 120 : 91,
                      backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                      fontSize: 16,
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                      padding: '9px 13px',
                      color: followedUp ? '#e9630c' : '#fff',
                      minWidth: 'auto',
                      boxShadow: 3,
                      height: 32,
                      '&:hover': {
                        backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                        textDecoration: 'none',
                      },
                      '&:focus': {
                        backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                      },
                      '&:active': {
                        backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        mt: -0.5,
                        color: followedUp ? '#e9630c' : '#fff',
                        fontSize: 14,
                        fontWeight: 400,
                      }}
                    >
                      {followedUp ? 'Followed Up' : 'Follow Up'}
                    </Typography>
                  </Button>
                </span>
              </TooltipHirist>
            ) : (
              <Button
                disabled={
                  followedUp ||
                  (isPro && !hasfollowup) ||
                  (app_status > 0 && isPro == true)
                }
                onClick={handleJobFollowup}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: '4px',
                  width: followedUp ? 120 : 91,
                  display: app_status <= 0 ? 'inline' : 'none',
                  backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                  fontSize: 16,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  padding: '9px 13px',
                  color: followedUp ? '#e9630c' : '#fff',

                  minWidth: 'auto',
                  boxShadow: 3,
                  height: 32,
                  '&:hover': {
                    backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                    textDecoration: 'none',
                  },
                  '&:focus': {
                    backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                  },
                  '&:active': {
                    backgroundColor: followedUp ? '#fff0e3' : '#e9630c',
                  },
                }}
              >
                <Typography
                  sx={{
                    mt: -0.5,
                    color: followedUp ? '#e9630c' : '#fff',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {followedUp ? 'Followed Up' : 'Follow Up'}
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>

      {/* Second Content Section */}
      <CardContent
        data-testid="applied-desktop-details"
        sx={{
          paddingBottom: '0px !important',
          paddingTop: 0,
          margin: 0,
          paddingLeft: 0,
          paddingRight: 0,
          borderRadius: 1,
        }}
      >
        <Grid
          container
          direction="row"
          spacing={0}
          paddingLeft={0}
          marginLeft={0}
          paddingRight={0}
          marginRight={0}
          paddingBottom={0}
        >
          <Grid
            item
            marginLeft={3}
            display="flex"
            mt={2.75}
            paddingBottom={0}
            marginBottom={confidential ? 2.5 : 0}
          >
            <Avatar
              data-testid="applied-desktop-recruiter-avatar"
              onClick={
                confidential
                  ? () => {}
                  : () => {
                      trackClick('Recruiter Name');
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              sx={{
                cursor: confidential ? 'default' : 'pointer',
                height: 50,
                width: 50,
                borderRadius: '10px',
                border: '1px solid #efefef',
              }}
              imgUrl={confidential ? '' : recruiterDetail.pictureLink}
            />
          </Grid>

          {/* Title and Subtext */}
          <Grid item paddingBottom={0} marginTop={2.125} xxs={4.08} pl={'15px'}>
            <Typography
              data-testid="applied-desktop-recruiter-name"
              component="a"
              href={confidential ? '' : recruiterDetail.profileUrl}
              sx={{
                paddingTop: 0,
                paddingBottom: 0,
                marginBottom: 0,
                fontSize: 16,
                fontWeight: '600 !important',
                fontStyle: 'normal',
                cursor: confidential ? 'default' : 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: confidential ? 'none' : 'underline',
                },
              }}
              onClick={
                confidential
                  ? event => {
                      event.preventDefault();
                    }
                  : event => {
                      event.preventDefault();
                      trackClick('Recruiter Name');
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              color="#0057ff"
            >
              {confidential ? 'Verified Recruiter' : recruiterDetail.name}
            </Typography>
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingTop: '0px',
                  paddingBottom: 0,
                  marginBottom: 0,
                  cursor: 'default',
                  fontSize: 14,
                  color: 'textPrimary',
                  fontWeight: 600,
                  fontStyle: 'normal',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  WebkitLineClamp: 2,
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                }}
              >
                {`${recruiterDetail.designation} at ${recruiterDetail.organisationName}`}
              </Typography>
            )}
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  visibility: lastActive ? 'visible' : 'hidden',
                  marginTop: 0.25,
                  paddingTop: 0,
                  marginBottom: 2,
                  fontSize: 14,
                  cursor: 'default',
                  fontWeight: 200,
                  fontStyle: 'normal',
                  color: 'textPrimary',
                }}
              >
                Last Active:{' '}
                {lastActive && lastActive?.lastActiveDate
                  ? !isNaN(new Date(lastActive.lastActiveDate).getTime())
                    ? new Date(lastActive?.lastActiveDate).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        timeZone: 'UTC',
                      }
                    )
                    : lastActive?.lastActiveDate
                  : ''}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            marginLeft={{xxs: 3.125}}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 2.875,
              paddingBottom: 0,
            }}
            xxs={5}
            lg={5.3}
          >
            {unpublishInfo &&
            unpublishInfo?.unpublishedDate &&
            unpublishInfo?.unpublishedDate > 1 ? (
              <Typography
                variant="body2"
                sx={{
                  height: 32,
                  cursor: 'default',
                  marginTop: 0,
                  paddingTop: 0,
                  fontSize: 14,
                  fontWeight: 300,
                  fontStyle: 'normal',
                  color: 'red !important',
                }}
              >
                This job was unpublished on{' '}
                {String(
                  new Date(unpublishInfo.unpublishedDate).getDate()
                ).padStart(2, '0')}
                -
                {String(
                  new Date(unpublishInfo.unpublishedDate).getMonth() + 1
                ).padStart(2, '0')}
                -{new Date(unpublishInfo.unpublishedDate).getFullYear()}
                <br></br>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 300,
                    fontStyle: 'normal',
                    color: '#797979',
                  }}
                >
                  {' '}
                  Reason: {unpublishInfo.unpublishReason}
                </Typography>
              </Typography>
            ) : (
              <></>
            )}
          </Grid>

          {/* {!isMedium ||
          !(
            unpublishInfo &&
            unpublishInfo?.unpublishedDate &&
            unpublishInfo?.unpublishedDate > 1
          ) ? (
            <Grid
              item
              marginLeft={{lg: 0, xxs: -12.125}}
              // marginTop={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: 0,
                justifyContent: 'center',
              }}
              xxs={2.1}
             
            >
              {inviteStatus ? (
                interviewDate &&
                interviewTime &&
                new Date(
                  new Date(interviewDate).setHours(
                    parseInt(interviewTime.slice(0, 2)),
                    parseInt(interviewTime.slice(2))
                  ) +
                    30 * 60 * 1000
                ) < new Date() ? (
                  <></>
                ) : (
                  <ScheduledInterview
                    slotId={slotId}
                    calId={calId}
                    remSlots={remSlots}
                    date={
                      interviewDate && interviewTime && inviteStatus > 1
                        ? (() => {
                            const dateObj = new Date(interviewDate);
                            dateObj.setHours(
                              parseInt(interviewTime.slice(0, 2)),
                              parseInt(interviewTime.slice(2))
                            );

                            return dateObj
                              .toLocaleString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true, // Use 24-hour format
                              })
                              .replace('at', ',')
                              .replace('am', 'AM')
                              .replace('pm', 'PM');
                          })()
                        : ''
                    }
                  />
                )
              ) : (
                <></>
              )}
              {isPro &&
              (app_status == 1 || (inviteStatus && app_status > 0)) &&
              !(
                unpublishInfo &&
                unpublishInfo?.unpublishedDate &&
                unpublishInfo?.unpublishedDate > 1
              ) ? (
                <Typography
                  onClick={initiateChat}
                  component="span"
                  sx={{
                    cursor: 'pointer',
                    fontSize: 12,
                    fontWeight: 500,
                    letterSpacing: '0.48px',
                    color: '#49966E',
                    verticalAlign: 'super',
                    marginBottom: 0,
                  }}
                >
                  Chat with Recruiter
                </Typography>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )} */}

          <Grid
            item
            marginLeft={0}
            sx={{
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              // marginTop: 3.375,
              justifyContent: 'center',
              paddingBottom: 0,
            }}
            xxs={1.56}
          >
            <Button
              data-testid="applied-desktop-insights-btn"
              onClick={openInsightsDialog}
              variant="text"
              color="primary"
              sx={{
                textTransform: 'none',
                padding: 0,
                fontSize: 15,
                border: 'none',
                boxShadow: 'none',
                whiteSpace: 'nowrap',
                fontWeight: 400,
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none',
                },
                '&:focus': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
                '&:active': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
              }}
            >
              <Box display={'flex'}>
                <Image
                  src={LineChart}
                  alt="lc"
                  width={20}
                  height={20}
                  style={{marginRight: '4px'}}
                ></Image>{' '}
                View Detailed Insights
              </Box>
            </Button>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                marginTop: 0.25,
                fontSize: 14,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                fontWeight: 200,
              }}
            >
              {formatPostedTime(jobDetail.createdTime)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AppliedTileV2;
